import DialogTitle from "@mui/material/DialogTitle";
import { useContext } from "react";
import DialogAnimate from "src/components/animate/DialogAnimate";
import useLocales from "src/hooks/useLocales";

// contexts
import Context from "../context";
import TransactionDetail from "./TransactionDetail";

export default function UnknownDetailDialog() {
	const { actions, state } = useContext(Context);
	const { translate } = useLocales();

	return (
		<DialogAnimate maxWidth='lg' onClose={actions.hideDetailDialog} open={state.isDetailVisible}>
			<DialogTitle>{translate("Detalle de transacción")}</DialogTitle>
			<TransactionDetail />
		</DialogAnimate>
	);
}
